import { StyleSheet } from 'react-native';

import { Colors } from '../Themes';

export default StyleSheet.create({
  containerStyle: {
    top: 0,
    right: 0,
    left: 0,
    justifyContent: 'center',
    height: 72.8,
    backgroundColor: Colors.blackTwo,
    zIndex: 10,
    flexDirection: 'row',
    paddingTop: 41.6,
  },
  alertMessage: {
    fontSize: 16.6,
    lineHeight: 22.9,
    color: Colors.white,
  },
  icon: {
    marginRight: 8,
  },
});
